import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import UniversalWebView from '@/components/UniversalWebView'
import { getJwtToken } from '@/lib/api/jwtOAuthApi'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import { Stack } from 'expo-router'
import { useEffect, useState } from 'react'
import { Linking, Platform, StyleSheet, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function CustomerServicePage() {
  const insets = useSafeAreaInsets()
  const [url, setUrl] = useState<string | null>(null)
  const headerLeftItems = useWebBackButton('/profile')

  useEffect(() => {
    ;(async () => {
      const token = await getJwtToken()
      if (!token) return

      const customerServiceUrl = `https://cs.jinshuju.net/?utm_device=mobile&utm_source=gd_app&utm_medium=nextapp&m_t=${token}`
      setUrl(customerServiceUrl)
    })()
  }, [])

  if (!url) return null

  return (
    <View style={[styles.container, Platform.OS === 'android' && { paddingBottom: insets.bottom }]}>
      <Stack.Screen
        options={{
          headerTransparent: false,
          ...buildScreenHeaderItems({ left: headerLeftItems }),
        }}
      />
      <UniversalWebView<{ type: 'openUrl'; payload: string }>
        source={{ uri: url }}
        style={styles.webview}
        injectedJavaScript={`
            (function() {
              window.addEventListener('click', function(event) {
                if (event.target.tagName !== 'A' || !event.target.href) {
                  return;
                }
                window.ReactNativeWebView.postMessage(JSON.stringify({
                  payload: event.target.href,
                  type: 'openUrl'
                }));

                event.preventDefault();
                event.stopPropagation();
              }, false);
            })();
            true;
          `}
        onMessage={data => {
          if (!data) return

          try {
            const { type, payload } = data
            if (type === 'openUrl') {
              Linking.openURL(payload)
            }
          } catch (error) {
            console.error('Failed to parse WebView message:', error)
          }
        }}
        {...(Platform.OS === 'android' && {
          geolocationEnabled: true,
        })}
      />
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  webview: {
    flex: 1,
  },
})
